"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtifactDownloader = void 0;
const debug_1 = __importDefault(require("debug"));
const core_1 = require("@integro/core");
const log = (0, debug_1.default)('itp:integro.helpers.ArtifactDownloader');
const OP_READ_ARTIFACT_JOB = 'read_artifact_job';
const OP_DOWNLOAD_ARTIFACT = 'download_artifact';
const POLL_INTERVAL = 1000;
class ArtifactDownloader {
    app;
    poller;
    jobData;
    error;
    isPending = false;
    isCompleted = false;
    isRunning = false;
    isErrored = false;
    onError;
    constructor(app, onError = null) {
        this.app = app;
        this.jobData = null;
        this.error = null;
        this.onError = onError;
    }
    begin(job) {
        log('begin job');
        this.isRunning = true;
        Promise.resolve(job)
            .then(d => this.initJob(d))
            .catch(err => this.updateState(null, err));
    }
    stop() {
        this.poller?.stop();
    }
    initJob(job) {
        this.poller = new core_1.Poller({
            name: 'ArtifactDownloader',
            callback: this.pollerCallback.bind(this),
            interval: POLL_INTERVAL,
            errback: err => this.onError && this.onError(err)
        });
        this.updateState(job, null);
        log('poller started');
    }
    async loadJob(artifact_id) {
        return this.app.connections.request(OP_READ_ARTIFACT_JOB, {
            parameters: { id: artifact_id }
        });
    }
    async pollerCallback() {
        try {
            const resp = await this.app.connections.request(OP_READ_ARTIFACT_JOB, {
                parameters: { id: this.jobData.artifact_id }
            });
            return this.updateState(resp.data, null);
        }
        catch (err) {
            return this.updateState(null, err);
        }
    }
    updateState(data, error = null) {
        try {
            if (data) {
                this.jobData = data;
                this.isPending = data.status === 'pending';
                this.isCompleted = data.status === 'completed';
            }
            this.setErrorStates(error);
            if (this.isPending && this.poller) {
                this.poller.start();
            }
            if (this.isRunning && !this.poller.isRunning) {
                this.poller.start();
            }
            if ((this.isCompleted || this.isErrored) &&
                this.poller &&
                this.poller.isRunning) {
                this.poller.stop();
                if (data) {
                    this.downloadArtifact(data);
                }
            }
            if (error && this.onError) {
                this.onError(error);
            }
            log('state changed job: %o, error: %o, downloader: %o', this.jobData, error, this);
        }
        catch (err) {
            this.setErrorStates(err);
            if (this.onError) {
                return this.onError(err);
            }
            console.error(err);
        }
    }
    setErrorStates(error) {
        if (error) {
            this.error = error;
            this.isErrored = true;
            this.isRunning = false;
        }
        else {
            this.error = null;
            this.isErrored = null;
        }
    }
    complete() {
        this.isPending = false;
        this.isCompleted = true;
        this.isRunning = false;
        this.isErrored = false;
        this.error = null;
    }
    downloadArtifact(data) {
        const url = this.app.connections.urlFor(OP_DOWNLOAD_ARTIFACT, {
            id: data.artifact_id
        });
        Promise.resolve(core_1.downloads.getFileBLOB(url, data.filename))
            .then(blob => core_1.downloads.downloadFile(blob.file, blob.fileName))
            .then(() => this.complete())
            .catch(err => {
            this.setErrorStates(err);
            if (this.onError) {
                return this.onError(err);
            }
            console.error(err);
        });
    }
}
exports.ArtifactDownloader = ArtifactDownloader;
